// ABOUTME: Simple plus icon for drop zone indicators
// ABOUTME: Supports className, size, and color customization via stroke

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const DropPlusIcon = ({ className = "", size = 24, color = "currentColor" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      stroke={color}
    />
  </svg>
)
